<template>
    <span
        class="badge text-dark d-inline-flex align-items-center font-weight-normal font-size-100 px-2 py-1 fw-bold"
        :class="addMarginClass ? classes + ' mr-2_' : classes"
        :title="title ? title : null"
    >
      <slot>
        <i v-if="isIconBeforeText && icon" :class="text ? icon + ' mr-2_' : icon"></i>
        <template v-if="text">{{ text }}</template>
        <i v-if="!isIconBeforeText && icon" :class="text ? icon + ' ml-2_' : icon"></i>
      </slot>
    </span>
</template>

<script>
export default {
    name: 'FileBadge',
    props: {
        addMarginClass: {
            default: true,
        },
        icon: {
            default: '',
        },
        isIconBeforeText: {
            default: false,
        },
        text: {
            default: '',
        },
        classes: {
            default: '',
        },
        title: {
            default: '',
        },
    },
};
</script>
